import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Plyr from 'react-plyr';
require('../../assets/scss/plyr.css')
let moment = require('moment')
import { connect } from "react-redux";
import FormLabel from "@material-ui/core/FormLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { Tooltip, Grid, Divider, Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText, TextField } from "@material-ui/core";
// material ui icons
import MailOutline from "@material-ui/icons/MailOutline";
import Contacts from "@material-ui/icons/Contacts";
import Check from "@material-ui/icons/Check";
import AddIcon from "@material-ui/icons/Add";
import RefreshIcon from "@material-ui/icons/Refresh"
import SubscribeIcon from "@material-ui/icons/Subscriptions"
import EditIcon from "@material-ui/icons/Edit"
import IconButton from '@material-ui/core/IconButton';
import * as track from '../../data/track/track';
import green from '@material-ui/core/colors/green';
// core components
import PodCastStatus from "./PodCastStatus"
import GridContainer from "src/components/Grid/GridContainer.jsx";
import GridItem from "src/components/Grid/GridItem.jsx";
import CustomInput from "src/components/CustomInput/CustomInput.jsx";
import Button from "src/components/CustomButtons/Button.jsx";
import Card from "src/components/Card/Card.jsx";

import CardHeader from "src/components/Card/CardHeader.jsx";
import CardText from "src/components/Card/CardText.jsx";
import CardIcon from "src/components/Card/CardIcon.jsx";
import CardBody from "src/components/Card/CardBody.jsx";
import CardFooter from "src/components/Card/CardFooter.jsx";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import Switch from "@material-ui/core/Switch";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import customSelectStyle from "src/assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import { cardTitle, tooltip } from "src/assets/jss/material-dashboard-pro-react.jsx";
import ImageUpload from "src/components/CustomUpload/ImageUpload.jsx";
import * as model from '../../data/model';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import * as types from '../../types'
import { SSL_OP_NETSCAPE_CA_DN_BUG } from "constants";
import * as firebase from 'firebase/app';
import CloudDownload from '@material-ui/icons/CloudDownload'
import Archive from '@material-ui/icons/Archive'
import {
    defaultFont,
    primaryColor,
    infoColor,
    successColor,
    warningColor,
    dangerColor
} from "src/assets/jss/material-dashboard-pro-react.jsx";

import TableHead from "@material-ui/core/TableHead";
import Table from "src/components/Table/Table.jsx";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import SubscribeDialog from './SubscribeDialog';
const styles = {
    cardTitle: {
        ...cardTitle,
        color: "#FFFFFF"
    },
    cardIconTitle: {
        ...cardTitle,
        marginTop: "15px",
        marginBottom: "0px"
    },
    ...customSelectStyle,
    buttonSuccess: {
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    successText: {
        color: successColor,
        paddingRight: '5px',
        paddingLeft: '5px'
    },
    subscribeButton: {


    },
    warningText: {
        color: warningColor,
        paddingRight: '5px',
        paddingLeft: '5px'
    },
    marginRight: {

    },
    center: {
        display: 'inline-grid',
        textAlign: 'center'
    },
    text: {
        width: '100%',
        color: 'red'
    },
    icons: {
        width: "17px",
        height: "17px",
        margin: 0
    },

};
let categories = model.PodCastCatgory.getCategories();
;
interface PodCastViewProps {
    classes: any;
    connect: types.IState
}
interface PodCastViewState {
    copied: boolean,
    open: boolean,
    refreshing: boolean
}
class PodCastView extends React.Component<PodCastViewProps, PodCastViewState> {
    constructor(props: PodCastViewProps) {
        super(props);
        this.state = {
            copied: false,
            open: false,
            refreshing: false

        };

    }
    handleClose() {
        let s = { ...this.state }
        s.open = false;
        this.setState(s);


    }
    handleOpen(e) {
        let s = { ...this.state }
        s.open = true;
        this.setState(s);


    }
    handleEdit(e) {

        types.ViewState.navigate(types.ViewState.hashPodCastEdit(this.props['match'].params.id))
    }

    render() {
        const { classes } = this.props;
        let me = this;

        //this.props.match.params
        if (!this.props.connect.lo_PodCasts.completed() || !this.props.connect.lo_Tracks.completed()) {
            return (<div></div>)
        }
        let podcast: model.PodCast = this.props.connect.lo_PodCasts.val().find(x => x.id == me.props['match'].params.id);
        if (!podcast) {
            return (<div>not found</div>)
        }
        let sort = podcast.podcast_type == model.PodCastType.rss ? this.props.connect.lo_ctx.val().Track.sortByPublishDate : this.props.connect.lo_ctx.val().Track.sortByCreateDate;

        let tracks = this.props.connect.lo_Tracks.val().filter(x => x.podcast_id == podcast.id).sort(sort);
        let isMobile = true;
        let podcastcompleted = podcast.feed_status == model.PodCastFeedStatus.ready && tracks.filter(x => x.status != model.TrackStatus.completed).length == 0
        let tableData = [];
        tracks.forEach(t => {
            let url = t.media.audio_url;
            console.log("url = " + url)
            if (url && url.indexOf('castablog.com') != -1) {
                // url= t.media.audio_url.replace("https://castablog.com","http://localhost:5000");
            }
            if (t.status != model.TrackStatus.completed) {
                url = "";
            }
            //  else url="https://castablog.com"
            let button: any = (<div></div>)
            if (t.status == model.TrackStatus.queued ||
                t.status == model.TrackStatus.processing ||
                t.status == model.TrackStatus.pendingPayment ||
                t.status == model.TrackStatus.prepareOnDemand) {
                //@ts-ignore;
                let diffMs = (new Date() - t.modified) as any;
                let difInMins = Math.round((((diffMs) % 86400000) % 3600000) / 60000);
                if (difInMins > 2) {
                    button = [(
                        <Button simple color="info" className={classes.actionButton} onClick={async (e) => {
                            try {
                                t.status = model.TrackStatus.draft;
                                await me.props.connect.lo_ctx.val().Track.save(t);
                                t.status = model.TrackStatus.prepareOnDemand;
                                await me.props.connect.lo_ctx.val().Track.save(t);

                            }
                            catch (e) {
                                track.Track.reportError(e,"Whoops! Error reprocessing Track",true,me.props.connect.dispatch);
                            }
                        }} >
                            <CloudDownload className={classes.icons}

                            /> Reprocess
                        </Button>),
                           <Button simple color="warning" onClick={(e) => {
                            if (confirm("Are you sure you want to archive " + t.title + "?")) {

                                me.props.connect.lo_ctx.val().Track.archive(t.id);
                                track.Track.Event(track.TrackCategory.webaction, track.TrackEvent.archiveTrack);
                            }
                        }} ><Archive className={classes.icons} />  Archive</Button>
                    ]
                }
                else {
                    button = (<div></div>)
                }

            
                //model.TrackStatus.prepareOnDemand
            }
            else if (t.status == model.TrackStatus.error) {


                button = (<div style={{
                    'display': 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>Error:{t.status_message}</div>);
            }
            else if (t.status == model.TrackStatus.completed) {
                button = [
                    (
                        <Button simple color="info" className={classes.actionButton} onClick={(e) => {
                            var link = document.createElement("a");
                            link.download = name;
                            link.target = "_blank"
                            link.href = t.media.audio_url;

                            link.click();
                            track.Track.Event(track.TrackCategory.webaction, track.TrackEvent.downloadTrackAudio);
                        }} >
                            <CloudDownload className={classes.icons}


                            /> Download
                        </Button>),
                    (
                        <Button simple color="warning" onClick={(e) => {
                            if (confirm("Are you sure you want to archive " + t.title + "?")) {

                                me.props.connect.lo_ctx.val().Track.archive(t.id);
                                track.Track.Event(track.TrackCategory.webaction, track.TrackEvent.archiveTrack);
                            }
                        }} ><Archive className={classes.icons} />  Archive</Button>
                    )

                ]
            }

            let linkUrl = t.source_url ? t.source_url : t.canonical_url;
            tableData.push([
                (<span>  {linkUrl &&
                    <a href={linkUrl} target='_blank'>{t.title}</a>
                }
                    {!linkUrl &&
                        <span> {t.title}</span>

                    }
                </span>),
                moment(t.publish_date).calendar(),

                (
                    <div style={{
                        'display': 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }} >
                        {t.status == model.TrackStatus.completed &&
                            <audio
                                controls
                                preload={t.status == model.TrackStatus.completed ? 'metadata' : 'none'}
                                src={url}>

                            </audio>
                        }
                        {t.status == model.TrackStatus.ondemand &&
                            <Button onClick={async (e) => {
                                let trackJobPayload = new model.bgConvertTrackTextToAudioPayload();
                                trackJobPayload.track_id = t.id;
                                console.log('job id  = ' + t.id)

                                let trackJob = model.BackgroundJob.create(model.bgJobType.ConvertTrackTextToAudio, trackJobPayload);
                                t.status = model.TrackStatus.processing;
                                await me.props.connect.lo_ctx.val().Track.save(t);
                                await me.props.connect.lo_ctx.val().BackgroundJob.save(trackJob);
                            }} >Convert to Audio</Button>


                        }
                        {(t.status == model.TrackStatus.queued ||
                            t.status == model.TrackStatus.processing ||
                            t.status == model.TrackStatus.pendingPayment ||
                            t.status == model.TrackStatus.prepareOnDemand) &&
                            <div  style={{
                                'display': 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                             
                            }}>Processing
                        <img width={20} height={20} alt={t.status.toString()} src='/loading.gif' />
                            </div>

                        }
                    </div>


                ), button

            ]);
        })
        podcast.podcast_type == model.PodCastType.rss
        return (
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="rose" icon>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={3}>
                                    <CardIcon color="rose">
                                        <img src={podcast.image_url} width='40px' height='40px' />
                                    </CardIcon>
                                    <h4 className={classes.cardIconTitle}>{podcast.title} </h4>
                                    <PodCastStatus podcast={podcast} />

                                </GridItem>
                                <GridItem xs={12} sm={12} md={9}>
                                    <div style={{ float: 'right' }}>
                                        <Button simple color='info' onClick={this.handleEdit.bind(this)}> <EditIcon className={classes.icons} /> Edit PodCast</Button>

                                        <Button simple color="primary" onClick={this.handleOpen.bind(this)}> <SubscribeIcon className={classes.icons} /> Subscribe to Podcast</Button>

                                        {podcast.podcast_type == model.PodCastType.adhoc &&
                                            <Button color='success' simple onClick={(e) => {
                                                types.ViewState.navigate(types.ViewState.hashTrackCreate(podcast.id))
                                            }} >

                                                <AddIcon className={classes.icons} /> Add Track
          </Button>
                                        }
                                        {podcast.podcast_type == model.PodCastType.rss &&
                                            <Button color='success' simple
                                                disabled={this.state.refreshing} onClick={async (e) => {
                                                    let s = { ...me.state };
                                                    s.refreshing = true;
                                                    me.setState(s);
                                                    await this.props.connect.lo_ctx.val().PodCast.sync(podcast.id);
                                                    s = { ...me.state };
                                                    s.refreshing = false;
                                                    me.setState(s);
                                                    //types.ViewState.navigate(types.ViewState.hashTrackCreate(podcast.id))
                                                }} >
                                                {this.state.refreshing &&
                                                    <span>Refreshing...</span>
                                                }
                                                {!this.state.refreshing &&
                                                    <span>                           <RefreshIcon className={classes.icons} /> Refresh</span>
                                                }
                                            </Button>
                                        }
                                    </div>

                                </GridItem>
                            </GridContainer>



                        </CardHeader>
                        <CardBody>
                            <div>

                                <GridContainer wrap='nowrap'>



                                </GridContainer>
                                <Table

                                    tableHead={['Title', 'Published', '', '']}
                                    tableData={tableData}

                                />


                            </div>



                        </CardBody>

                    </Card>
                </GridItem>
                <SubscribeDialog
                    open={this.state.open}
                    podcast_id={podcast.id}
                    close={this.handleClose.bind(this)} />
            </GridContainer >
        );
    }
}

export function mapStateToProps(state: types.IState) {
    return {
        connect: state
    };
}
export default connect(
    mapStateToProps,
    null
)(withStyles(styles as any)(PodCastView));




// WEBPACK FOOTER //
// ./src/views/podcast/PodCastView.tsx